import {UserModel} from '../auth'

export interface ICustomerLedgerFormType {
  username: string
  userId: number | null
  sdate: string
  edate: string
}

export interface ILedger {
  date: string
  reference: string
  debit: number
  credit: number
  type: string
  running_balance: number
  sort_order: number
  invoice_id?: number
  voucher_id?: number
}

export interface IUserDetails extends UserModel {
  user_img: string
}

export interface ICustomerLedgerResponse {
  userDetails: IUserDetails
  ledgerDetails: ILedger[]
}

export const initCustomerLedgerFormValues: ICustomerLedgerFormType = {
  username: '',
  userId: null,
  sdate: '',
  edate: '',
}
